import Auth from '@/packages/Auth';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import VeeValidate, { Validator } from 'vee-validate';
import ja from 'vee-validate/dist/locale/ja';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import Meta from 'vue-meta';
import ToggleButton from 'vue-js-toggle-button';
import Paginate from 'vuejs-paginate';
import linkify from 'vue-linkify';

import App from './App.vue';
import './assets/css/styles.css';
import router from './router';
import store from './store';
import doubleByte from './validators/doubleByte';


Vue.use(Auth);
Vue.use(VeeValidate, {
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
  classes: true,
});
Validator.localize('ja', ja);
Validator.localize('ja', {
  custom: {
    phone: {
      length: '有効な電話番号ではありません。',
    },
    password: {
      doubleByte: 'パスワードは、半角英数字記号のみ入力可能です。',
    },
    current_password: {
      required: '現在のパスワードは必須項目です',
    },
    email: {
      required: 'メールアドレスは必須項目です',
    },
    years_of_attendance: {
      required: '在籍年数は必須項目です',
      decimal: '在籍年数は必須項目です',
    },
    last_year_income: {
      required: '直近年収（万円）は必須項目です',
      decimal: '直近年収（万円）は必須項目です',
    },
    number_of_experience_companies: {
      required: 'これまでの経験社数は必須項目です',
      decimal: 'これまでの経験社数は必須項目です',
    },
    screening_intention: {
      required: '転職に関する現時点での意向は必須項目です',
    },
    token: {
      required: '認証コードは必須項目です',
    },
    job_summary: {
      required: '職務経歴書のアップロード、または業務内容の入力のいずれかをお願いします。',
    },
    resume: {
      required_if: '職務経歴書の添付、または職務要約をテキストで入力のいずれかをお願いします。',
      size: '1MB未満のPDFをアップロードしてください。',
      ext: 'ファイルが無効なため1MB未満のPDFをアップロードしてください。',
    },
    cv: {
      required: 'プロフィールをアップロードしてください',
      size: '1MB未満のPDFをアップロードしてください',
      ext: 'ファイルが無効なため1MB未満のPDFをアップロードしてください。',
    },
    last_furigana: {
      required: '姓のふりがなは必須項目です',
    },
    furigana: {
      required: '名のふりがなは必須項目です',
    }
  },
});
Validator.extend('doubleByte', doubleByte);
axios.defaults.withCredentials = true;
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(Meta);
Vue.use(ToggleButton);
Vue.component('vue-paginate', Paginate);
Vue.directive('linkified', linkify);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
